<template>
    <v-app>
        <v-card v-if="order.id" :loading="loading">
            <v-card-title class="py-0">
                <h2 class="font-weight-regular my-2 py-0">
                    {{
                        $vuetify.breakpoint.smAndDown
                            ? 'WO'
                            : 'Process work order'
                    }}
                    <span class="font-weight-black"
                        >{{ order.code }}
                        {{
                            $vuetify.breakpoint.smAndDown
                                ? ''
                                : `| ${order.project.reference} ${order.project.name}`
                        }}</span
                    >
                </h2>
                <v-spacer />
            </v-card-title>
            <v-divider class="ml-4 mr-5 py-0" />
            <v-card-text class="px-4 my-0 py-0">
                <v-tabs
                    v-model="tab"
                    ref="tabs"
                    active-class="white"
                    background-color="grey lighten-3"
                    hide-slider
                >
                    <v-tab
                        v-for="section in sections"
                        :key="section"
                        class="text-uppercase"
                    >
                        {{ section }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items touchless v-model="tab">
                    <v-tab-item>
                        <div
                            :id="
                                $vuetify.breakpoint.smAndDown ||
                                $vuetify.breakpoint.lg
                                    ? 'virtual-scroll-table'
                                    : 'componente'
                            "
                            :style="
                                `height: ${
                                    $vuetify.breakpoint.xs
                                        ? $vuetify.breakpoint.height - 110
                                        : $vuetify.breakpoint.sm
                                        ? $vuetify.breakpoint.height - 250
                                        : $vuetify.breakpoint.height - 124
                                }px`
                            "
                        >
                            <WOGeneralInfo
                                :workOrder="order"
                                :readOnlyWO="true"
                                :isAnonymous="isAnonymous"
                                @close="close"
                            />
                        </div>
                    </v-tab-item>
                    <v-tab-item v-if="!isAnonymous">
                        <BOM :workOrder="order" />
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
            <!--Error Alert-->
            <Errors />
            <!--Error Message for Anonymous Users-->
            <v-alert
                v-if="showError"
                type="error"
                color="error"
                :style="{
                    position: 'absolute',
                    right: '0px',
                    bottom: '0px',
                    zIndex: 9999,
                }"
                dismissible
                @input="showError = false"
            >
                {{ errorMessage }}
            </v-alert>
        </v-card>
    </v-app>
</template>

<script>
import API from '@/services/api'
import WOMethods from './WOMethods.js'

export default {
    name: 'PublicProcessWorkOrder',
    props: {
        orderId: {
            type: String,
            required: true,
        },
    },
    components: {
        WOGeneralInfo: () =>
            import('@/components/WorkOrders/WOGeneralInfo.vue'),
        Errors: () => import('@/components/Layout/Errors'),
        BOM: () => import('@/components/WorkOrders/BOM.vue'),
    },
    data: () => ({
        loading: false,
        sections: ['general information'],
        tab: null,
        order: {},
        woMethods: new WOMethods(),
        isAnonymous: false,
        errorMessage: '',
        showError: false,
    }),
    async mounted() {
        try {
            this.loading = true
            this.woMethods = new WOMethods()
            const companyId = this.$route.query.companyId

            // Check if user is anonymous
            try {
                const {
                    data: { user },
                } = await API.getMyInfo()
                this.isAnonymous = user.name === 'AnonymousSession'
            } catch (error) {
                // If getMyInfo fails, assume anonymous
                this.isAnonymous = true
            }

            // Only show BOM tab if user is not anonymous
            if (!this.isAnonymous) {
                this.sections.push('bom')
            }

            this.order = await API.findWOByCode(this.orderId, companyId)
            if (!this.order.formatted) {
                this.order = this.woMethods.formatItems(this.order)
            }
            const {
                data: { settings },
            } = await API.getSettings(companyId ? { companyId } : {})
            const settingProcesses = settings.find(s => s.name == 'Processes')
            this.woMethods.setProcessesInfo({
                workOrder: this.order,
                settingProcesses: settingProcesses,
            })
        } catch (error) {
            console.error('Error loading Work Order:', error)
            // Show error message to user
            this.errorMessage = error.message || 'Failed to load Work Order'
            this.showError = true
        } finally {
            this.loading = false
        }
    },
    methods: {
        close() {
            // No-op for public view
        },
    },
}
</script>

<style></style>
